module.exports = __webpack_public_path__ + "img/instagram.1.39a3267e.svg";